import React, { useState } from 'react';
import { LazyBlock } from '../../../types/api/Block';
import { BlockType } from '../../../types/api/ElementType';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { ButtonMinorAction } from '../../../components/molecules/Btn/ButtonWrapper';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { Icons } from '../../../components/atoms/SVG';
import { ModalDialogModifier } from '../../../components/organisms/ModalDialog/ModalDialog';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { PageStatisticsBlock } from '../../PageStatistics';

export function PageStatisticsButton({ pageStatistics }: { pageStatistics: LazyBlock<BlockType.pagestatistics> }) {
  const { t } = useSonTranslation('PageInteractions');
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const statisticsTranslation = t('statistics.title');

  return (
    <div className="page-interactions__button-container">
      <ButtonMinorAction
        icon={Icons.ANALYSIS}
        text={statisticsTranslation}
        onClick={() => setModalOpen(true)}
        tooltipPlacement={TooltipPlacement.TOP}
      />
      {modalOpen && (
        <ModalDialog
          modifier={ModalDialogModifier.WIDE}
          closeModal={() => setModalOpen(false)}
          headline={statisticsTranslation}
        >
          <PageStatisticsBlock {...pageStatistics} />
        </ModalDialog>
      )}
    </div>
  );
}
